import React from "react";

const PageNotFound = () => {
  return (
    <div className="row" id="pagenotfound">
      <div className="container-fluid">
        <div className="subpage-banner text-center">
          <h2>404</h2>
          <div className="auto-h3">Page Not Found</div>
        </div>
      </div>
      <div className="container text-center">
        <div className="mb-3 mt-3">
          <p>The page you are trying to view is not available</p>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
